'use strict';

const _=require('pulsar-utils/dist-es6/_');let

NonReentrantCommand=class NonReentrantCommand{
constructor(awaitableAction,$timeout,rx){
this._awaitableAction=awaitableAction;
this._$timeout=$timeout;
this._inProgress=!1;

this._onInProgressChangedSubject=new rx.Subject;
}

async execute(){
if(this._inProgress){
return;
}
this._inProgress=!0;
this._onInProgressChangedSubject.onNext(this._inProgress);
this._$timeout(()=>{});
await this._awaitableAction.apply(this,_.toArray(arguments));
this._inProgress=!1;
this._onInProgressChangedSubject.onNext(this._inProgress);
this._$timeout(()=>{});
}

get inProgress(){
return this._inProgress;
}

get onInProgressChanged(){
return this._onInProgressChangedSubject;
}};



module.exports=NonReentrantCommand;
//# sourceMappingURL=nonReentrantCommand.js.map
